<template>
  <div>
    <h5 class="mt-2 subheading" v-if="groupedDiseases.length === 0">{{ `app.interview.diseases` | trans }}</h5>
    <v-divider v-if="groupedDiseases.length === 0"></v-divider>
    <span v-if="groupedDiseases.length === 0">{{ `app.no_data`|trans }}</span>
    <v-layout v-if="groupedDiseases.length !== 0">
      <v-flex xs6><h5 class="text-uppercase text-bold">{{ `app.interview.disease` | trans }}</h5></v-flex>
      <v-flex xs6><h5 class="text-uppercase text-bold">{{ `app.interview.medicines` | trans }}</h5></v-flex>
    </v-layout>
    <div v-for="(diseases, groupIndex) in groupedDiseases" v-bind:key="groupIndex" class="mb-5">
      <div v-if="diseases.length > 0">
        <h5 class="mt-4 subheading">{{ `app.interview.diseases_groups.` + groupIndex | trans }}</h5>
        <v-divider></v-divider>
        <v-layout v-for="(disease, diseaseIndex) in diseases" v-bind:key="diseaseIndex">
          <v-flex xs6>{{ disease.name }}</v-flex>
          <v-flex xs6>{{ disease.medicines }}</v-flex>
        </v-layout>
      </div>
    </div>
    <h5 class="mt-4 subheading">{{ `app.interview.gastrointestinal_symptoms` | trans }}</h5>
    <v-divider></v-divider>
    <span v-if="withoutVitamins.length === 0">{{ `app.no_data`|trans }}</span>
    <v-layout row wrap>
      <v-flex xs6 v-for="symptom in withoutVitamins" v-bind:key="symptom.id" class="no-padding">{{ symptom.name }}</v-flex>
    </v-layout>
    <h5 class="mt-4 subheading">{{ `app.interview.vitamin_deficiency_symptoms` | trans }}</h5>
    <v-divider></v-divider>
    <span v-if="lowVitamins.length === 0">{{ `app.no_data`|trans }}</span>
    <ul>
      <li v-for="symptom in lowVitamins">
        {{ symptom.name }} <span v-if="symptom.nutrients" class="font-italic">({{ symptom.nutrients }})</span>
      </li>
    </ul>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {trans} from "../../../app";

export default {
  data() {
    return {
      withoutVitaminsResponse: [],
      lowVitaminsResponse: [],
      groupedDiseasesResponse: [],
    }
  },
  async created() {
    await this.fetchSymptoms();
    await this.fetchDiseases();
  },
  computed: {
    ...mapGetters(['interview']),
    withoutVitamins: function () {
      return this.withoutVitaminsResponse.filter((symptom) => {
        return this.interview.symptoms.includes(symptom.id);
      });
    },
    lowVitamins: function () {
      return this.lowVitaminsResponse.filter((symptom) => {
        return this.interview.symptoms.includes(symptom.id);
      });
    },
    groupedDiseases: function () {
      let groupedDiseases = [];
      this.groupedDiseasesResponse.forEach((group, groupIndex) => {
        groupedDiseases[groupIndex] = [];
        group.forEach((disease) => {
          const interviewDisease = this.interview.diseases[disease.id]
          if (interviewDisease) {
            const medicines = interviewDisease.medicine === null ? trans('app.no_data') : interviewDisease.medicine;
            const name = disease.name === 'Inne' ? interviewDisease.name : disease.name;
            groupedDiseases[groupIndex].push({
              name: name,
              medicines: medicines
            });
          }
        });
      });
      return groupedDiseases;
    },
  },
  methods: {
    async fetchSymptoms() {
      try {
        const withoutVitaminsResponse = await axios.get('/v2/symptoms/without_vitamins');
        this.withoutVitaminsResponse = withoutVitaminsResponse.data.data;

        const lowVitaminsResponse = await axios.get('/v2/symptoms/low_vitamins')
        this.lowVitaminsResponse = lowVitaminsResponse.data.data;
      } catch (error) {
        this.sentryCaptureException(error);
      }
    },
    async fetchDiseases() {
      try {
        const response = await axios.get('/v2/diseases')
        this.groupedDiseasesResponse = response.data;
      } catch (error) {
        this.sentryCaptureException(error);
      }
    },
  }
}
</script>